import type { SVGProps } from 'react'
const SvgPlayArrowWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="M7.496 4.855A1 1 0 0 0 6 5.723v12.554a1 1 0 0 0 1.496.868l10.985-6.277a1 1 0 0 0 0-1.736z"
    />
  </svg>
)
export default SvgPlayArrowWhite
